import Button, { ButtonWrapper } from 'blocks/Button';
import Form, { TextField } from 'components/Form';
import Modal from 'components/Modal';
import { ModalFC } from 'config/types';
import { ModalVerifyCodeFormModel, ModalVerifyCodeProps } from 'pages/signup/signup.interface';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as S from './modalVerifyCode.styles';

const ModalVerifyCode: ModalFC<ModalVerifyCodeProps> = ({ open, loading, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const {
    register,
    getValues,
    formState: { errors },
  } = useForm<ModalVerifyCodeFormModel>();

  const onVerify = async () => {
    await onSubmit(getValues('code'));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Form>
        <S.InputWrapper>
          <TextField
            control={register('code', {
              required: t('pages.signup.sections.verification.fields.verifyCode.emptyError') as string,
            })}
            error={errors.code}
            label={t('pages.signup.sections.verification.fields.verifyCode.label')}
          />
        </S.InputWrapper>

        <ButtonWrapper justify="center">
          <Button
            loading={loading}
            onClick={() => {
              onVerify();
            }}
          >
            {t('pages.signup.sections.verification.submitCTA')}
          </Button>
        </ButtonWrapper>
      </Form>
    </Modal>
  );
};

export default ModalVerifyCode;
